import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import copy from 'copy.json'
import { adminPanelPaths } from 'paths'

const text = copy.components.searchNavigation

export default function SearchScreenNavigation() {
  return (
    <Wrapper>
      <NavLink to={adminPanelPaths.seller.search}>{text.seller}</NavLink>
      <NavLink to={adminPanelPaths.buyer.search}>{text.buyer}</NavLink>
      <NavLink to={adminPanelPaths.matches_search}>{text.matches}</NavLink>
    </Wrapper>
  )
}

const Wrapper = styled.nav`
  display: flex;
  background: var(--very-light-blue);
  margin-bottom: -16px;
  border-bottom: 1px solid var(--light-gray);

  a {
    font: var(--400-15);
    text-decoration: none;
    color: inherit;
    padding: 9px 24px 7px;
    border-bottom: 2px solid transparent;

    &.active {
      font-weight: 600;
      border-bottom-color: var(--green);
    }
  }
`
